export class ResellerSettings {
	public myBrandtrack: {
		billingSectionEnabled: boolean
		zoneCreateEnabled: boolean
		zoneEditEnabled: boolean
		zoneDeleteEnabled: boolean
		zoneRefreshEnabled: boolean
		zoneViewPlaylistsEnabled: boolean
		zoneInstallationInfoEnabled: boolean
		zoneEventsNumber: number
		locationEditEnabled: boolean
		locationDeleteEnabled: boolean
		locationShareEnabled: boolean
		groupFeatureEnabled: boolean
		radioUnlimitedSongs: boolean
		radioLastTimeUpdatedEnabled: boolean
		radioAssignPlaylistEnabled: boolean
		radioDeletedSongsEnabled: boolean
		radioDiscoverEnabled: boolean
		radioAddCustomEnabled: boolean
		radioFeedbackEnabled: boolean
		radioModifyPlaylistEnabled: boolean
		radioRatePlaylistEnabled: boolean
		musicProfileFeatureEnabled: boolean
		campaignCreateEnabled: boolean
		campaignCreateAiEnabled: boolean
		campaignCreateAiCustomDescription: string
		campaignEditEnabled: boolean
		campaignDeleteEnabled: boolean
		accountMusicLegalComplianceEnabled: boolean
		integrationsFeatureEnabled: boolean
		privacyPolicyEnabled: boolean
		dataDeletionEnabled: boolean
		registratonEnabled: boolean
	}
	public directlyInvoiced?: boolean
	public resellerName?: string
	public resellerId?: number

	public get isBillingEnabled(): boolean {
		return this.myBrandtrack?.billingSectionEnabled !== false
	}

	constructor(data: {
		myBrandtrack: {
			billingSectionEnabled: boolean
			zoneCreateEnabled: boolean
			zoneEditEnabled: boolean
			zoneDeleteEnabled: boolean
			zoneRefreshEnabled: boolean
			zoneViewPlaylistsEnabled: boolean
			zoneInstallationInfoEnabled: boolean
			zoneEventsNumber: number
			locationEditEnabled: boolean
			locationDeleteEnabled: boolean
			locationShareEnabled: boolean
			groupFeatureEnabled: boolean
			radioUnlimitedSongs: boolean
			radioLastTimeUpdatedEnabled: boolean
			radioAssignPlaylistEnabled: boolean
			radioDeletedSongsEnabled: boolean
			radioDiscoverEnabled: boolean
			radioAddCustomEnabled: boolean
			radioFeedbackEnabled: boolean
			radioModifyPlaylistEnabled: boolean
			radioRatePlaylistEnabled: boolean
			musicProfileFeatureEnabled: boolean
			campaignCreateEnabled: boolean
			campaignCreateAiEnabled: boolean
			campaignCreateAiCustomDescription: string
			campaignEditEnabled: boolean
			campaignDeleteEnabled: boolean
			accountMusicLegalComplianceEnabled: boolean
			integrationsFeatureEnabled: boolean
			privacyPolicyEnabled: boolean
			dataDeletionEnabled: boolean
			registratonEnabled: boolean
		}
		directlyInvoiced?: boolean
		resellerName?: string
		resellerId?: number
	}) {
		this.myBrandtrack = data.myBrandtrack
		this.directlyInvoiced = data.directlyInvoiced
		this.resellerName = data.resellerName
		this.resellerId = data.resellerId
	}

	static create(partial: Partial<ResellerSettings>): ResellerSettings {
		const defaults = {
			myBrandtrack: {
				billingSectionEnabled: false,
				zoneCreateEnabled: false,
				zoneEditEnabled: false,
				zoneDeleteEnabled: false,
				zoneRefreshEnabled: false,
				zoneViewPlaylistsEnabled: false,
				zoneInstallationInfoEnabled: false,
				zoneEventsNumber: 0,
				locationEditEnabled: false,
				locationDeleteEnabled: false,
				locationShareEnabled: false,
				groupFeatureEnabled: false,
				radioUnlimitedSongs: false,
				radioLastTimeUpdatedEnabled: false,
				radioAssignPlaylistEnabled: false,
				radioDeletedSongsEnabled: false,
				radioDiscoverEnabled: false,
				radioAddCustomEnabled: false,
				radioFeedbackEnabled: false,
				radioModifyPlaylistEnabled: false,
				radioRatePlaylistEnabled: false,
				musicProfileFeatureEnabled: false,
				campaignCreateEnabled: false,
				campaignCreateAiEnabled: false,
				campaignCreateAiCustomDescription: '',
				campaignEditEnabled: false,
				campaignDeleteEnabled: false,
				accountMusicLegalComplianceEnabled: false,
				integrationsFeatureEnabled: false,
				privacyPolicyEnabled: false,
				dataDeletionEnabled: false,
				registratonEnabled: false,
			},
		}

		return new ResellerSettings({ ...defaults, ...partial })
	}
}
